import DashboardTrafficInformationAPI from './dashboard-traffic-information.api'

export default DashboardTrafficInformationAPI